import React, { useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import UserContext from "../context/UserContext.js";
import "./NavBar.css";

const NavBar = ({ logout }) => {
  const { currentUser } = useContext(UserContext);

  const loggedInNav = () => (
    <header className="navbar-custom">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand-custom">
          Bells+Whistles
        </Link>
        <ul className="navbar-links">
          <li>
            <NavLink className="nav-link-custom" to="/">Home</NavLink>
          </li>
          <li>
            <NavLink className="nav-link-custom" to="/spaces">Spaces</NavLink>
          </li>
          <li>
            <NavLink className="nav-link-custom" to="/locations">By Location</NavLink>
          </li>
          <li>
            <NavLink className="nav-link-custom" to="/categories">By Category</NavLink>
          </li>
          <li className="nav-divider" aria-hidden="true" />
          <li>
            <NavLink className="nav-link-custom" to={`/users/${currentUser.username}`}>Profile</NavLink>
          </li>
          <li>
            <NavLink className="nav-link-custom" to={`/users/${currentUser.username}/edit`}>Edit Profile</NavLink>
          </li>
          <li>
            <NavLink className="nav-link-custom" to={`/users/${currentUser.username}/spaces`}>My Spaces</NavLink>
          </li>
          {currentUser.isAdmin && (
            <li>
              <NavLink className="nav-link-custom" to="/users">Users</NavLink>
            </li>
          )}
          <li>
            <NavLink className="nav-link-custom nav-logout" to="/" onClick={logout}>
              Log out
            </NavLink>
          </li>
        </ul>
      </div>
    </header>
  );

  const anonNav = () => (
    <header className="navbar-custom">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand-custom">
          Bells+Whistles
        </Link>
        <ul className="navbar-links">
          <li>
            <NavLink className="nav-link-custom" to="/login">Sign In</NavLink>
          </li>
          <li>
            <NavLink className="nav-link-custom nav-signup" to="/signup">Get Started</NavLink>
          </li>
        </ul>
      </div>
    </header>
  );

  return currentUser ? loggedInNav() : anonNav();
};

export default NavBar;
